{
  "version": 1,
  "asset_id": "19368d7e-da26-4779-97b8-fdcfa625e338",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/19368d7e-da26-4779-97b8-fdcfa625e338/hiatal-type-1-v3-1200.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/19368d7e-da26-4779-97b8-fdcfa625e338/hiatal-type-1-v3-1200.jpg",
  "original_filename": "hiatal-type-1-v3-1200.jpg",
  "size": 197678,
  "content_type": "image/jpeg",
  "created_at": "2026-10-28T23:09:13Z"
}
